import { Col, Form, Row, Tooltip } from 'antd';
import { Button, RadioGroup } from 'components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import { useForm } from 'antd/lib/form/Form';
import BeneficialOwners from './beneficialOwners';
import { cloneDeep, size } from 'lodash';
import { extractValueFromEvent } from 'utils/helpers';
import styles from './SubTab3.module.scss';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';

const SubTab3 = ({ disabled, extended }) => {
  const [totalParticipationPercentage, setTotalParticipationPercentage] = useState(null);
  const carrier = useSelector(state => state.forms.carrier);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode;
  const [form] = useForm();
  const dispatch = useDispatch();

  const beneficialOwners = useSelector(
    state => state.forms.carrier.beneficialOwners
  ) || [
    {
      fullName: null,
      taxId: null,
      birthDate: null,
      participationPercentage: null,
      role: null,
    },
  ];

  const handleChange = ({ key, type, event }) => {
    let newValue = extractValueFromEvent(type, event);

    if (type === 'radio' && key === 'hasShareholdersFlag') {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'errorCheckHandlingShareholders',
          value: true,
        })
      );
      if (event.target.value === false) {
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'beneficialOwners',
            value: null,
          })
        );
      }
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const handleChangeUsers = ({ key, value }) => {
    dispatch(updateFormField({ group: 'carrier', key, value }));
  };

  const addMore = () => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'beneficialOwners',
        value: [
          ...beneficialOwners,
          {
            fullName: null,
            taxId: null,
            birthDate: null,
            participationPercentage: null,
            role: null,
          },
        ],
      })
    );
  };

  const removeUser = key => {
    const value = beneficialOwners.filter((_, index) => index !== key);
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'beneficialOwners',
        value,
      })
    );
  };

  useEffect(() => {
    if (size(beneficialOwners) < 1) {
      addMore();
    }
  }, [beneficialOwners]);

  const renderUsers = () =>
    beneficialOwners.map((item, index) => (
      <BeneficialOwners
        item={item}
        key={index}
        index={index}
        disabled={viewMode}
        removeUser={removeUser}
        update={({ key, newValue, index }) => {
          const newUsers = [...beneficialOwners];
          newUsers[index] = {
            ...newUsers[index],
            [key]: newValue,
          };
          handleChangeUsers({
            key: 'beneficialOwners',
            value: newUsers,
          });
        }}
        beneficialOwners={beneficialOwners}
        addUsers={addMore}
      />
    ));

  useEffect(() => {
    var newValues = cloneDeep(beneficialOwners);
    form.setFieldsValue({ beneficialOwners: newValues });

    const fieldsToValidate = newValues.flatMap((user, index) => {
      const { fullName, taxId, birthDate, participationPercentage, role } =
        user;

      // Skip validation if all three fields are empty
      const isAllEmpty =
        !fullName && !taxId && !birthDate && !participationPercentage && !role;
      if (isAllEmpty) return [];

      // Otherwise, include the relevant fields for validation
      return [
        ['beneficialOwners', index, 'fullName'],
        ['beneficialOwners', index, 'taxId'],
        ['beneficialOwners', index, 'birthDate'],
        ['beneficialOwners', index, 'participationPercentage'],
        ['beneficialOwners', index, 'role'],
      ];
    });

    form.validateFields(fieldsToValidate);
  }, [carrier.beneficialOwners]);

  useEffect(() => {
    form.setFieldsValue({ beneficialOwners: beneficialOwners });
  }, [carrier.beneficialOwners]);

  useEffect(()=> {
    const total = beneficialOwners.reduce((sum, s) => {
        const val = Number(s.participationPercentage);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
    
      setTotalParticipationPercentage(total)       
  },[beneficialOwners])

  return (
    <div
      className={styles.subTab3BeneficialOwners}
      style={{ minHeight: 600, marginBottom: 200 }}
    >
      <Form
        form={form}
        name="shareHolders"
        initialValues={{ ...carrier }}
        preserve={false}
        className={styles.beneficialOwnersForm}
      >
        <div
          className="carrier-data-form "
          style={{ width: '100%', display: 'inline-block' }}
        >
          <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
            Στοιχεία Πραγματικών Δικαιούχων
            {/* <Tooltip
                placement="bottom"
                // className="ml-1"
                title={
                  <div className="tooltip-container">
                  <span className="info-icon-content">
                    <b>Πως επιλέγεται το πλαίσιο κρατικών ενισχύσεων;</b>
                    <br></br>
                    Η επιλογή του πλαισίου κρατικής ενίσχυσης γίνεται βάσει των δαπανών που θέλετε να χρηματοδοτήσετε, καθώς και του ύψους της επένδυσης.
                  </span>
                </div>
                }
              >
                <Info className="infoIconSmallIban" />
            </Tooltip> */}
          </p>

          {/* <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 22 }} className="mt-3">
            <Col span={24}>
              <RadioGroup
                label="Υπάρχουν άλλοι Εταίροι/Μέτοχοι στον Φορέα της Επένδυσης;"
                defaultValue={'no'}
                options={[
                  { label: 'Ναι', id: 'yesOption', value: true },
                  { label: 'Όχι', id: 'noOption', value: false },
                ]}
                name={'hasShareholdersFlag'}
                checked={carrier?.hasShareholdersFlag}
                value={carrier?.hasShareholdersFlag}
                id={`hasShareholdersFlag`}
                disabled={viewMode}
                onChange={event =>
                  handleChange({ key: event.target.name, type: 'radio', event })
                }
              />
            </Col>
          </Row> */}
          {
            <Row
              gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
              className="shareHoldersWrapper"
            >
              <Col span={24}>{renderUsers()}</Col>
              {!viewMode && (
                <>
                  <Col>
                    { (totalParticipationPercentage !== 100 ) && (
                      <>
                        <div className="ant-form-item-explain-error">
                          Το άθροισμα των ποσοστών Συμμετοχής πρέπει να είναι 100%
                        </div>
                      </>
                    )}
                  </Col>
                  <Col span={24}>
                    <Button
                      className="mt-2 addMoreBtn"
                      label={'Προσθήκη'}
                      onClick={addMore}
                    />
                  </Col>
                </>
              )}
            </Row>
          }
        </div>
      </Form>
    </div>
  );
};

export default SubTab3;
